<template>
  <div v-if="!loading">
    <div class="mb-3">
      <h3>
        {{ $t("field.proposals_to_approve") }}
      </h3>
    </div>
    <div v-if="pendingProposals.length">
      <div
        v-for="(proposal, index) in pendingProposals"
        :key="index"
        class="
          w-100
          d-flex
          flex-column
          align-items-start
          justify-content-center
        "
      >
        <b-button
          v-b-toggle="'accordion-' + index"
          variant="unstyled"
          class="border-bottom rounded-0 w-100 d-flex justify-content-between"
        >
          <div>
            <span class="ml-1 font-weight-bold text-primary">{{
              proposal.subject
            }}</span>
          </div>
          <div class="d-flex align-items-center">
            <b-button
              variant="unstyled"
              class="p-0"
              @click.stop="goToProposal(proposal.budget_id)"
            >
              <font-awesome-icon
                :icon="faExternalLinkAlt"
                class="text-primary mr-3"
              />
            </b-button>
            <font-awesome-icon :icon="faChevronRight" class="accordion-icon" />
          </div>
        </b-button>
        <b-collapse
          :id="'accordion-' + index"
          class="pt-2 w-100 bg-gray-200 border-bottom"
        >
          <div class="container">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                mt-2
                mb-0
              "
            >
              <p class="item">
                <span class="font-weight-bold">{{ $t("field.status") }}</span>
              </p>
              <p class="item">
                <span class="font-weight-bold">{{
                  $t("field.expiration_date")
                }}</span>
              </p>
              <p class="item">
                <span class="font-weight-bold">{{ $t("field.user") }}</span>
              </p>
            </div>
            <div class="mt-3 d-flex align-items-center justify-content-around">
              <p class="item text-capitalize">
                {{ proposal.budget.status }}
              </p>
              <p class="item">
                {{ proposal.expiration_date }}
              </p>
              <p class="item">
                {{ getUser(proposal.budget.user_id) }}
              </p>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div v-else class="mb-3">
      <p class="font-weight-bold fs-12 pl-2">
        {{
          $t("list.no_data", {
            data: this.$t("field.proposals_to_approve").toLowerCase(),
          })
        }}
      </p>
    </div>
    <div>
      <div class="my-3">
        <h3>
          {{ $t("field.proposals_sent") }}
        </h3>
      </div>
      <div v-if="proposalsSent.length">
        <div
          v-for="(proposal, index) in proposalsSent"
          :key="index"
          class="
            w-100
            d-flex
            flex-column
            align-items-start
            justify-content-center
          "
        >
          <b-button
            v-b-toggle="'accordion-sent' + index"
            variant="unstyled"
            class="border-bottom rounded-0 w-100 d-flex justify-content-between"
          >
            <div>
              <span class="ml-1 font-weight-bold text-primary">{{
                proposal.subject
              }}</span>
            </div>
            <div class="d-flex align-items-center">
              <b-button
                variant="unstyled"
                class="p-0"
                @click.stop="goToProposal(proposal.budget_id)"
              >
                <font-awesome-icon
                  :icon="faExternalLinkAlt"
                  class="text-primary mr-3"
                />
              </b-button>
              <font-awesome-icon
                :icon="faChevronRight"
                class="accordion-icon"
              />
            </div>
          </b-button>
          <b-collapse
            :id="'accordion-sent' + index"
            class="pt-2 w-100 bg-gray-200 border-bottom"
          >
            <div class="container">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-2
                  mb-0
                "
              >
                <p class="item">
                  <span class="font-weight-bold">{{ $t("field.status") }}</span>
                </p>
                <p class="item">
                  <span class="font-weight-bold">{{
                    $t("field.expiration_date")
                  }}</span>
                </p>
                <p class="item">
                  <span class="font-weight-bold">{{ $t("field.user") }}</span>
                </p>
              </div>
              <div
                class="mt-3 d-flex align-items-center justify-content-around"
              >
                <p class="item text-capitalize">
                  {{ proposal.status }}
                </p>
                <p class="item">
                  {{ proposal.expiration_date }}
                </p>
                <p class="item">
                  {{ getUser(proposal.user_id) }}
                </p>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
      <div v-else class="mb-3">
        <p class="font-weight-bold fs-12 pl-2">
          {{
            $t("list.no_data", {
              data: this.$t("field.proposals_sent").toLowerCase(),
            })
          }}
        </p>
      </div>
      <div class="my-3">
        <h3>
          {{ $t("field.proposals_completed") }}
        </h3>
        <div v-if="proposalsCompleted.length" class="mb-3">
          <div
            v-for="(proposal, index) in proposalsCompleted"
            :key="index"
            class="
              w-100
              d-flex
              flex-column
              align-items-start
              justify-content-center
            "
          >
            <b-button
              v-b-toggle="'accordion-completed' + index"
              variant="unstyled"
              class="
                border-bottom
                rounded-0
                w-100
                d-flex
                justify-content-between
              "
            >
              <div>
                <span class="ml-1 font-weight-bold text-primary">{{
                  proposal.subject
                }}</span>
              </div>
              <div class="d-flex align-items-center">
                <b-button
                  variant="unstyled"
                  class="p-0"
                  @click.stop="goToProposal(proposal.budget_id)"
                >
                  <font-awesome-icon
                    :icon="faExternalLinkAlt"
                    class="text-primary mr-3"
                  />
                </b-button>
                <font-awesome-icon
                  :icon="faChevronRight"
                  class="accordion-icon"
                />
              </div>
            </b-button>
            <b-collapse
              :id="'accordion-completed' + index"
              class="pt-2 w-100 bg-gray-200 border-bottom"
            >
              <div class="container">
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-2
                    mb-0
                  "
                >
                  <p class="item">
                    <span class="font-weight-bold">{{
                      $t("field.status")
                    }}</span>
                  </p>
                  <p class="item">
                    <span class="font-weight-bold">{{
                      $t("field.expiration_date")
                    }}</span>
                  </p>
                  <p class="item">
                    <span class="font-weight-bold">{{ $t("field.user") }}</span>
                  </p>
                </div>
                <div
                  class="mt-3 d-flex align-items-center justify-content-around"
                >
                  <p class="item text-capitalize">
                    {{ proposal.status }}
                  </p>
                  <p class="item">
                    {{ proposal.expiration_date }}
                  </p>
                  <p class="item">
                    {{ getUser(proposal.user_id) }}
                  </p>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <div v-else>
          <p class="font-weight-bold fs-12 pl-2">
            {{
              $t("list.no_data", {
                data: this.$t("field.proposals_completed").toLowerCase(),
              })
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>
<script>
import {
  faChevronRight,
  faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons'
import api from '@/api/proposal'
import budgetsApi from '@/api/budgets'
import usersApi from '@/api/users'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    api,
    budgetsApi,
    usersApi,
    faChevronRight,
    faExternalLinkAlt,
    loading: true,
    pendingProposals: [],
    proposalsSent: [],
    approvedProposals: [],
    rejectedProposals: [],
    proposalsCompleted: [],
    isOpen: false,
    users: []
  }),
  async created() {
    this.loading = true

    await this.init()

    this.loading = false
  },
  computed: {
    ...mapGetters({
      activeCompany: 'company/activeCompany'
    }),
    filterProposalsSent() {
      return {
        user_id: this.$auth.user().id,
        status: 'Aguarda aprovação',
        company_id: this.activeCompany.id
      }
    },
    filterApprovedProposals() {
      return {
        user_id: this.$auth.user().id,
        company_id: this.activeCompany.id,
        status: 'Aprovado',
        skip: 0,
        take: 5
      }
    },
    filterRejectedProposals() {
      return {
        user_id: this.$auth.user().id,
        company_id: this.activeCompany.id,
        status: 'Rejeitado',
        skip: 0,
        take: 5
      }
    }
  },
  watch: {
    async activeCompany() {
      this.loading = true
      this.pendingProposals = []
      this.proposalsSent = []
      this.approvedProposals = []
      this.rejectedProposals = []
      this.proposalsCompleted = []
      await this.init()
      this.loading = false
    }
  },
  methods: {
    async init() {
      await Promise.all([
        this.getPendingProposals(),
        this.getProposalsSent(),
        this.getApprovedProposals(),
        this.getRejectedProposals(),
        this.getUsers()
      ])

      this.proposalsCompleted = [
        ...this.approvedProposals,
        ...this.rejectedProposals
      ]

      this.loading = false
    },
    async getPendingProposals() {
      try {
        const response = await this.api.pending(this.$auth.user().id, {
          company_id: this.activeCompany.id
        })

        if (response && response.data && response.data.list) {
          this.pendingProposals = response.data.list
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getProposalsSent() {
      try {
        const response = await this.budgetsApi.all(this.filterProposalsSent)

        if (response && response.data && response.data.list) {
          response.data.list.map(budget => {
            budget.proposals.map(proposal => {
              let proposalData = {
                ...proposal,
                status: budget.status,
                user_id: budget.user_id
              }
              this.proposalsSent.push(proposalData)
            })
          })
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getApprovedProposals() {
      try {
        const response = await this.budgetsApi.all(this.filterApprovedProposals)

        if (response && response.data && response.data.list) {
          response.data.list.map(budget => {
            budget.proposals.map(proposal => {
              let proposalData = {
                ...proposal,
                status: budget.status,
                user_id: budget.user_id
              }
              this.approvedProposals.push(proposalData)
            })
          })
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getRejectedProposals() {
      try {
        const response = await this.budgetsApi.all(this.filterRejectedProposals)

        if (response && response.data && response.data.list) {
          response.data.list.map(budget => {
            budget.proposals.map(proposal => {
              let proposalData = {
                ...proposal,
                status: budget.status,
                user_id: budget.user_id
              }
              this.rejectedProposals.push(proposalData)
            })
          })
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getUsers() {
      try {
        const response = await this.usersApi.all()

        if (response && response.data && response.data.list) {
          this.users = response.data.list
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    collapseStatus() {
      this.isOpen = !this.isOpen
    },
    goToProposal(id) {
      return this.$router.push({ name: 'budgetsUpdate', params: { id: id } })
    },
    getUser(user_id) {
      if (user_id) {
        const user = this.users.find(user => user.id === user_id)

        return user.name
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>